import Button from '../../components/button/Button'
import { Formik, Form, ErrorMessage, Field } from 'formik'
import * as Yup from 'yup'
import './addInquiry.scss'
import NewInput from '../../components/input/NewInput'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { preferredBatch, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import {
  convertDateFormatCalendar,
  generateDropdownOptions,
  handleEmail,
  handleInput,
  handleInputAddress,
  handleName,
} from '../../utility/genricFunction'
import { useDispatch, useSelector } from 'react-redux'
import {
  createInquiry,
  editInquiry,
  getInquirySources,
  getInquiryById,
} from '../../store/builders/inquiry/inquiry.builder'
import { setInquiryType } from '../../store/slice/inquiry/inquiry.slice'
import { getBatch } from '../../store/builders/branch/branch.builder'
import { getCourseListByBranchId } from '../../store/builders/course/course.builder'
import Calendar from '../../components/calendar/Calendar'
import {
  getAreaByCityId,
  getCityByStateId,
  getEducationQualification,
  getTempAreaByCityId,
  getTempCityByStateId,
} from '../../store/builders/masterDataSet/masterDataSet.builder'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import Loader from '../../components/loader/Loader'
import dayjs from 'dayjs'

const AddInquiryForm = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, inquiryType, inquiryById, inquirySources } = useSelector((state) => state.inquiry)
  const { CitiesAreas, stateCities, states } = useSelector((state) => state.masterDataSet)
  const { tempCitiesAreas, tempStateCities } = useSelector((state) => state?.masterDataSet)
  const { CourseListByBranchId } = useSelector((state) => state.course)
  const inquiryHandle = useSelector((state) => state.auth.userList)
  const { branchTableData, batchData } = useSelector((state) => state?.branch)
  const batches = batchData?.result?.batches
  const [isSameAddress, setIsSameAddress] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState('alive')
  const educationQualificationData = useSelector(store=>store?.masterDataSet?.educationQualificationData)
  const [initialValues, setInitialValues] = useState({
    branchId: null,
    courseId: null,
    name: '',
    telephonicDate: null,
    phone: '',
    alternatePhone: '',
    educationQualification: '',
    inquiryType: inquiryType,
    passingYear: '',
    collegeName: '',
    preferredBatch: '',
    inquirySource: null,
    inquiryHandledBy: null,
    remarks: '',
    inquiryStatus: selectedStatus,
    nextFollowupDate: null,
    inquiryDate: null,
    permanentAddress: '',
    permanentArea: '',
    permanentCity: '',
    permanentState: '',
    temporaryAddress: '',
    temporaryArea: '',
    temporaryState: '',
    temporaryCity: '',
    email: '',
    residenceNumber: '',
    workExperienceYear: '',
    workExperienceMonth: '',
    companyName: '',
    interpretation: '',
    followupDate: dayjs(),
    followupRemarks: '',
    followupStage: '',
    planningJoinOn: null,
    priority: '',
  })

const location = window.location.pathname == `/inquiry/new-inquiry/T2W/${id}`
  useEffect(() => {
    if (id) {
      dispatch(getInquiryById(id))
    }
    return () => dispatch({ type: 'inquiry/clearExtraReducers' })
  }, [id, dispatch])

  function convertWorkExperience(totalMonths) {
    const years = Math.floor(totalMonths / 12).toString()
    const months = (totalMonths % 12).toString()
    return { years, months }
  }

  useEffect(() => {
    dispatch(getBatch())
    dispatch(getInquirySources())
    dispatch(getEducationQualification())
  }, [])
  
  
  useEffect(() => {
    if (id) {
      // Extract the relevant data
      const data = inquiryById || {}
      const { years: workExperienceYear, months: workExperienceMonth } = convertWorkExperience(data.workExperience)
      data.branchId && dispatch(getCourseListByBranchId(data.branchId ))
      setInitialValues({
        inquiryId: data.inquiryId || '',
        name: data.name || '',
        branchId: data.branchId || null,
        courseId: data.courseId || null,
        email: data.email || '',
        inquiryDate: data.inquiryDate || null,
        phone: data.phone || '',
        alternatePhone: data.alternatePhone || '',
        educationQualification: data.educationQualification || '',
        inquiryType: id && inquiryType==='walkin' ? (data.inquiryType==="telephonic" ||data.inquiryType==="t2w") ? 't2w': 'walkin'  : data.inquiryType === 't2w'? "walkin" : data.inquiryType,
        passingYear: data.passingYear || '',
        collegeName: data.collegeName || '',
        preferredBatch: data.preferredBatch || '',
        inquirySource: data.inquirySource || null,
        inquiryHandledBy: data.inquiryHandledBy || null,
        inquiryStatus: data.inquiryStatus || '',
        permanentAddress: data.permanentAddress || '',
        permanentArea: data.permanentAreaId || '',
        permanentCity: data.permanentCityId || '',
        permanentState: data.permanentStateId || '',
        temporaryAddress: data.temporaryAddress || '',
        temporaryArea: data.temporaryArea || '',
        temporaryState: data.temporaryState || '',
        temporaryCity: data.temporaryCity || '',
        residenceNumber: data.residenceNumber || '',
        workExperienceYear: workExperienceYear || '',
        workExperienceMonth: workExperienceMonth || '',
        companyName: data.companyName || '',
        interpretation: data.interpretation || '',
        remarks: '',
        followupDate: dayjs(),
        nextFollowupDate: '',
        followupRemarks: '',
        followupStage: '',
        planningJoinOn: null,
        priority: '',
        ...(id && location && { inquiryTypeT2w: true })
      })
      setSelectedStatus(data.inquiryStatus)
      dispatch(setInquiryType(id && inquiryType==='walkin' ? inquiryType==='t2w'? inquiryType: 'walkin' :  data.inquiryType=== 't2w'? "walkin" : data.inquiryType ))
      setIsSameAddress(data.temporaryAddress === data.permanentAddress)
    }
  }, [id, inquiryById, inquiryType, dispatch])

  const telephonicValidationSchema = Yup.object({
    name: Yup.string().required(VALIDATION_MESSAGES.NAME_REQUIRED),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, VALIDATION_MESSAGES.PHONE_VALID)
      .required(VALIDATION_MESSAGES.PHONE_NUMBER_REQUIRED),
    email: Yup.string()
      .matches(/\S+@\S+\.\S+/, VALIDATION_MESSAGES.EMAIL_VALID),
    // courseId: Yup.string().required('Course name is required'),
    inquiryDate: Yup.string().required(VALIDATION_MESSAGES.INQUIRY_DATE),
    priority: Yup.string().required(VALIDATION_MESSAGES.PRIORITY_REQUIRED),
    // nextFollowupDate: Yup.string().required('Next followup date is required'),
  })
  const walkinValidationSchema = Yup.object({
    name: Yup.string().required(VALIDATION_MESSAGES.NAME_REQUIRED),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, VALIDATION_MESSAGES.PHONE_VALID)
      .required(VALIDATION_MESSAGES.PHONE_NUMBER_REQUIRED),
    email: Yup.string()
      .matches(/\S+@\S+\.\S+/, VALIDATION_MESSAGES.EMAIL_VALID)
      .required(VALIDATION_MESSAGES.EMAIL_REQUIRED),
    // courseId: Yup.string().required('Course name is required'),
    inquiryDate: Yup.string().required(VALIDATION_MESSAGES.INQUIRY_DATE),
    priority: Yup.string().required(VALIDATION_MESSAGES.PRIORITY_REQUIRED),
    // nextFollowupDate: Yup.string().required('Next followup date is required'),
  })

  const inquirySource = useMemo(
    () => generateDropdownOptions(inquirySources, 'inquirySourceName', 'inquirySourceId'),
    [inquirySources],
  )
  const educationQualification = useMemo(
    () => generateDropdownOptions(educationQualificationData, 'educationQualificationName', 'educationQualificationId'),
    [educationQualificationData],
  )
  
  const interpretation = [
    { label: 'Positive ', value: 'positive' },
    { label: 'Negative', value: 'negative' },
    { label: 'NotSure', value: 'notSure' },
  ]
  
  const priority = [
    { label: 'Hot', value: 'hot' },
    { label: 'Cold', value: 'cold' },
    { label: 'Warm', value: 'warm' },
  ]

  const year = [
    { label: '2000', value: '1' },
    { label: '2001', value: '2' },
    { label: '2002', value: '3' },
    { label: '2003', value: '4' },
    { label: '2004', value: '5' },
    { label: '2005', value: '6' },
    { label: '2006', value: '7' },
  ]

  const handleCheckboxChange = (setFieldValue, values) => (event) => {
    setIsSameAddress(event.target.checked)
    
    if (event.target.checked) {
      setFieldValue('temporaryAddress', values.permanentAddress)
      setFieldValue('temporaryArea', values.permanentArea)
      setFieldValue('temporaryCity', values.permanentCity)
      setFieldValue('temporaryState', values.permanentState)
    } else {
      setFieldValue('temporaryAddress', '')
      setFieldValue('temporaryArea', '')
      setFieldValue('temporaryCity', '')
      setFieldValue('temporaryState', '')
    }
  }

  const titleFunc = () =>{

    if(id &&  window.location.pathname == `/inquiry/new-inquiry/T2W/${id}`){
      return UI_CONSTANT.INQUIRY.NEW_INQUIRY
    }
    else if (id && window.location.pathname == `/inquiry/edit-inquiry/${id}` ){
      return UI_CONSTANT.INQUIRY.EDIT_INQUIRY
    }
    else{
      return UI_CONSTANT.INQUIRY.LABEL_INQUIRY
    }
  }

  const breadCrumbsArr = [
    {
      title:titleFunc(),
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.INQUIRY.LABEL_INQUIRY,
      link: ROUTES_PATH.INQUIRY,
    },
    {
      title: titleFunc(),
      link: id ? ROUTES_PATH.EDIT_INQUIRY.replace(':id', id) : ROUTES_PATH.NEW_INQUIRY,
    },
  ]

  const handleStateOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const stateId = e.target.value
    setFieldValue('permanentState', stateId)
    stateId && dispatch(getCityByStateId(stateId))
    setFieldValue('permanentCity', '')
    setFieldValue('permanentArea', '')
    // if (isSameAddress) {
    //   setFieldValue('temporaryState', stateId)
    // }
  }

  const handleCityOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const cityId = e.target.value
    setFieldValue('permanentCity', cityId)
    cityId && dispatch(getAreaByCityId(cityId)) 
    // if (isSameAddress) {
    //   setFieldValue('temporaryCity', cityId)
    // }
  }

  const handleAreaOnchange = (e, setFieldValue) => {
    e.preventDefault()
    const areaId = e.target.value
    setFieldValue('permanentArea', areaId)
    // if (isSameAddress) {
    //   setFieldValue('temporaryArea', areaId)
    // }
  }

  const handleTempStateOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const TempStateId = e.target.value
    setFieldValue('temporaryState', TempStateId)
    TempStateId && dispatch(getTempCityByStateId(TempStateId)) 
    setFieldValue('temporaryCity', '')
    setFieldValue('temporaryArea', '')
  }

  const handleTempCityOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const TempCityId = e.target.value
    setFieldValue('temporaryCity', TempCityId)
    TempCityId ? dispatch(getTempAreaByCityId(TempCityId)) : ''
  }

  const handleTempAreaOnchange = (e, setFieldValue) => {
    e.preventDefault()
    const TempAreaId = e.target.value
    setFieldValue('temporaryArea', TempAreaId)
  }

  const handleBranchOnChange = (e, setInitialValues) => {
    e.preventDefault()
    const branchId = e.target.value
    branchId ? dispatch(getCourseListByBranchId(branchId)) : ''
    setInitialValues('branchId', branchId)
  }

  return (
    <>
    {loading && <Loader loading={loading} />}
     {<Loader loading={loading} /> && <div className='inquiryForm-wrapper'>
        <Formik
          initialValues={initialValues}
          validationSchema={inquiryType === 'walkin' ? walkinValidationSchema : telephonicValidationSchema}
          enableReinitialize
          onSubmit={(values) => {
            if (id || inquiryById) {
              dispatch(editInquiry({ values, navigate }))
            } else {
              dispatch(createInquiry({ values, navigate }))
            }
          }}
        >
          {({ setFieldValue, values, handleChange, handleSubmit }) => (
            <Form>
              <div className='inquiryForm-header'>
                <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

                <div className='inquiryForm-header-right'>
                  <Button customClassName={'save-btn'} onClick={handleSubmit}>
                    {loading ? UI_CONSTANT.LOADING : UI_CONSTANT.SAVE}
                  </Button>
                </div>
              </div>
              <div className='inquiryType'>
                <div className='inquiryForm'>
                  <div className='inquiryForm-input-fields'>
                    <div className='inquiryForm-input-inquiry'>
                      <label>
                        Inquiry Type is<span className='required-symbol'>*</span>
                      </label>
                      <div className='inquiryType-btn-group'>
                        <Button
                          customClassName={inquiryType === 'walkin' ? 'active-btn' : 'inactive-btn'}
                          type='button'
                          onClick={() => {
                            dispatch(setInquiryType('walkin'))
                            setFieldValue('inquiryType', 'walkin') // Update Formik state
                          }}
                        >
                          Walk-In
                        </Button>
                        <Button
                          customClassName={inquiryType === 'telephonic' ? 'active-btn' : 'inactive-btn'}
                          type='button'
                          onClick={() => {
                            dispatch(setInquiryType('telephonic'))
                            setFieldValue('inquiryType', 'telephonic') // Update Formik state
                          }}
                          disabled={(inquiryType==='walkin'|| inquiryType==='t2w' ) && location }
                        >
                          Telephonic
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='inquiryForm'>
                <div className='inquiryForm-inner-header'>
                  <h1>{UI_CONSTANT.INQUIRY.PERSONAL_INFORMATION}</h1>
                  <p>{UI_CONSTANT.INQUIRY.FORM_DESCRIPTION}</p>
                </div>
                <div className='separatorLine'></div>
                <div className='inquiryForm-input-fields-form'>
                  <NewInput
                    label='Name'
                    placeholder='Enter name'
                    name='name'
                    // width={'32%'}
                    width={'100%'}
                    required={true}
                    onInput={handleName}
                  />
                  <NewInput
                    label='Mobile No'
                    placeholder='Enter mobile no'
                    name='phone'
                    // width={'32%'}
                    width={'100%'}
                    type='text'
                    onInput={handleInput}
                    required={true}
                    maxLength={10}
                  />
                  <NewInput
                    label='Alternative No'
                    placeholder='Enter alternative no'
                    name='alternatePhone'
                    // width={'32%'}
                    width={'100%'}
                    type='text'
                    onInput={handleInput}
                    maxLength={10}
                  />
                  <NewInput
                    label='Email'
                    placeholder='Enter email'
                    name='email'
                    // width={'32%'}
                    width={'100%'}
                    required={inquiryType === 'walkin' ? true : false}
                    maxLength={50}
                    onInput={handleEmail}
                  />

                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Permanent State</label>
                    <PageDropdown
                      options={generateDropdownOptions(states, 'state_name', 'state_id')}
                      selectedValue={values.permanentState}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleStateOnChange(e, setFieldValue)}
                      name={'permanentState'}
                      placeholder={'Select permanent state'}
                    />
                    <ErrorMessage name='permanentState' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Permanent City</label>
                    <PageDropdown
                      options={generateDropdownOptions(stateCities, 'city_name', 'city_id')}
                      selectedValue={values.permanentCity}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleCityOnChange(e, setFieldValue)}
                      name={'permanentCity'}
                      placeholder={'Select permanent city'}
                      disabled={!values.permanentState}
                    />
                    <ErrorMessage name='permanentCity' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Permanent Area</label>
                    <PageDropdown
                      options={generateDropdownOptions(CitiesAreas, 'area_name', 'area_id')}
                      selectedValue={values.permanentArea}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleAreaOnchange(e, setFieldValue)}
                      name={'permanentArea'}
                      placeholder={'Select permanent Area'}
                      disabled={!values.permanentCity}
                    />
                    <ErrorMessage name='permanentArea' component='div' className='error-msg' />
                  </div>
                  <NewInput
                    label='Permanent Address'
                    placeholder='Enter full address'
                    name='permanentAddress'
                    width={'98%'}
                    onInput={handleInputAddress}
                    maxLength={100}
                  />

                  <div className='inquiryForm-input1'>
                    <Field
                      type='checkbox'
                      name='sameAsPermanent'
                      checked={isSameAddress}
                      onChange={handleCheckboxChange(setFieldValue, values)}
                      className={`${isSameAddress ? 'custom-checkbox-checked' : ''}`}
                    />
                    <p>Temporary Address Same as Above</p>
                  </div>

                  {/* <div className='inquiryForm-input-fields-form'> */}

                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Temporary State</label>
                    <PageDropdown
                      options={generateDropdownOptions(states, 'state_name', 'state_id')}
                      selectedValue={values.temporaryState}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleTempStateOnChange(e, setFieldValue)}
                      name={'temporaryState'}
                      placeholder={'Select State'}
                      disabled={isSameAddress}
                    />
                    <ErrorMessage name='temporaryState' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Temporary City</label>
                    <PageDropdown
                      options={isSameAddress? generateDropdownOptions(stateCities, 'city_name', 'city_id'):  generateDropdownOptions(tempStateCities, 'city_name', 'city_id')}
                      selectedValue={values.temporaryCity}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleTempCityOnChange(e, setFieldValue)}
                      name={'temporaryCity'}
                      placeholder={'Select  city'}
                      disabled={isSameAddress || !values.temporaryState}
                    />
                    <ErrorMessage name='temporaryCity' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Temporary Area</label>
                    <PageDropdown
                      options={ isSameAddress?generateDropdownOptions(CitiesAreas, 'area_name', 'area_id') :  generateDropdownOptions(tempCitiesAreas, 'area_name', 'area_id')}
                      selectedValue={values.temporaryArea}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleTempAreaOnchange(e, setFieldValue)}
                      name={'temporaryArea'}
                      placeholder={'Select  Area'}
                      disabled={isSameAddress || !values.temporaryCity}
                    />
                    <ErrorMessage name='temporaryArea' component='div' className='error-msg' />
                  </div>

                  <NewInput
                    label='Temporary Address'
                    placeholder='Enter full address'
                    name='temporaryAddress'
                    width={'98%'}
                    disabled={isSameAddress}
                    onInput={handleInputAddress}
                    maxLength={100}
                  />
                  {/* </div> */}
                </div>
              </div>

              <div className='inquiryForm'>
                <div className='inquiryForm-inner-header'>
                  <h1>{UI_CONSTANT.INQUIRY.INQUIRY_DETAILS}</h1>
                  <p>{UI_CONSTANT.INQUIRY.FORM_DESCRIPTION}</p>
                </div>
                <div className='separatorLine'></div>

                <div className='inquiryForm-input-fields-form'>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Branch</label>
                    <PageDropdown
                      options={generateDropdownOptions(branchTableData, 'branchName', 'branchId')}
                      selectedValue={values.branchId}
                      className={'inquiryForm-dropdown'}
                      onChange={(e) => handleBranchOnChange(e, setFieldValue)}
                      name={'branchId'}
                      placeholder={'Select branch'}
                    />
                    <ErrorMessage name='branchId' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Course</label>
                    <PageDropdown
                      options={generateDropdownOptions(CourseListByBranchId, 'courseName', 'courseId')}
                      selectedValue={values.courseId}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'courseId'}
                      placeholder={'Select course'}
                      disabled={!values.branchId}
                    />
                    <ErrorMessage name='courseId' component='div' className='error-msg' />
                  </div>
                  {/* <DateTimeCalendar
                    label='Inquiry Date & Time'
                    // width='32%'
                    width='100%'
                    name='inquiryDate'
                    required={true}
                    value={values.inquiryDate}
                    onChange={(values) => setFieldValue('inquiryDate', values)}
                    gap='20px'
                  /> */}
                  <Calendar
                    label='Inquiry Date'
                    // width='48%'
                    required
                    name='inquiryDate'
                    value={values.inquiryDate}
                    onChange={(values) => setFieldValue('inquiryDate', convertDateFormatCalendar(values))}
                  />
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Preferred Batch</label>
                    <PageDropdown
                      options={preferredBatch}
                      selectedValue={values.preferredBatch}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'preferredBatch'}
                      placeholder={'Select Batch'}
                    />
                    <ErrorMessage name='preferredBatch' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Inquiry Source</label>
                    <PageDropdown
                      options={inquirySource}
                      selectedValue={values.inquirySource}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'inquirySource'}
                      placeholder={'Select Inquiry Source'}
                    />
                    <ErrorMessage name='inquirySource' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Inquiry Handled By</label>
                    <PageDropdown
                      options={generateDropdownOptions(inquiryHandle, 'userName', 'userId')}
                      selectedValue={values.inquiryHandledBy}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'inquiryHandledBy'}
                      placeholder={'Select Inquiry Handled By'}
                    />
                    <ErrorMessage name='inquiryHandledBy' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Interpretation</label>
                    <PageDropdown
                      options={interpretation}
                      selectedValue={values.interpretation}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'interpretation'}
                      placeholder={'Select Interpretation'}
                    />
                    <ErrorMessage name='interpretation' component='div' className='error-msg' />
                  </div>
                </div>
              </div>
              <div className='inquiryForm'>
                <div className='inquiryForm-inner-header'>
                  <h1>{UI_CONSTANT.INQUIRY.EDUCATION_BACKGROUND}</h1>
                  <p>{UI_CONSTANT.INQUIRY.FORM_DESCRIPTION}</p>
                </div>
                <div className='separatorLine'></div>
                <div className='inquiryForm-input-fields-form'>
                  <div className='inquiryForm-input'>
                    <label htmlFor=''>Educational Qualification</label>
                    <PageDropdown
                      options={educationQualification}
                      selectedValue={values.educationQualification}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'educationQualification'}
                      placeholder={'Select Educational Qualification'}
                    />
                    <ErrorMessage name='educationQualification' component='div' className='error-msg' />
                  </div>
                  <div className='inquiryForm-input'>
                    {/* <label htmlFor=''>Passing Year</label> */}
                    {/* <PageDropdown
                      options={year}
                      selectedValue={values.passingYear}
                      className={'inquiryForm-dropdown'}
                      onChange={handleChange}
                      name={'passingYear'}
                      placeholder={'Select year'}
                    /> */}
                    <NewInput
                    label='Passing Year'
                    placeholder='Enter Passing Year'
                    name='passingYear'
                    // width={'32%'}
                    width={'100%'}
                    type='text'
                    onInput={handleInput}
                    maxLength={4}
                  />
                    {/* <ErrorMessage name='educationQualification' component='div' className='error-msg' /> */}
                  </div>
                  <NewInput
                    label='College Name'
                    placeholder='Enter College Name'
                    name='collegeName'
                    // width={'32%'}
                    width={'100%'}
                    onInput={handleName}
                  />
                </div>
              </div>

              <div className='inquiryForm'>
                <div className='inquiryForm-inner-header'>
                  <h1>{UI_CONSTANT.INQUIRY.WORK_EXPERIENCE}</h1>
                  <p>{UI_CONSTANT.INQUIRY.FORM_DESCRIPTION}</p>
                </div>
                <div className='separatorLine'></div>

                <div className='inquiryForm-input-fields'>
                  <NewInput
                    label='Experience'
                    placeholder='Enter years'
                    name='workExperienceYear'
                    width={'16%'}
                    onInput={handleInput}
                    maxLength={2}
                    // width={"100%"}
                  />

                  <div className='hiddenLabel half-width'>
                    <NewInput
                      maxLength={2}
                      label='Experience'
                      onInput={handleInput}
                      placeholder='Enter months'
                      name='workExperienceMonth'
                      width={'100%'}
                    />
                  </div>

                  <div className='flex-1'>
                    <NewInput
                      label='Company Name'
                      placeholder='Enter Company Name'
                      name='companyName'
                      width={'100%'}
                      onInput={handleName}
                    />
                  </div>
                </div>
              </div>

              <div className='inquiryForm'>
                <div className='inquiryForm-inner-header'>
                  <h1>{UI_CONSTANT.INQUIRY.FOLLOWUP_PLANNING}</h1>
                  <p>{UI_CONSTANT.INQUIRY.FORM_DESCRIPTION}</p>
                </div>
                <div className='separatorLine'></div>
                <div className='mainClass'>
              <div className='labelClass'>
                <div className='innerClass'>
                  <Calendar
                    label='Followup Date'
                    // width='48%'
                    name='followupDate'
                    value={values.followupDate}
                    onChange={(values) => setFieldValue('followupDate', convertDateFormatCalendar(values))}
                    defaultToToday={true}
                  />

                  <div className='followupForm-input'>
                  <label htmlFor=''>
                      Priority<span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={priority}
                      selectedValue={values.priority}
                      className={'followupForm-dropdown'}
                      onChange={handleChange}
                      name={'priority'}
                      placeholder={'Select priority'}
                    />
                    <ErrorMessage name='priority' component='div' className='error-msg' />
                  </div>
                </div>
                <div className='innerClass'>
                  <div className='followupForm-input-textarea'>
                    <label htmlFor=''>Followup Remarks</label>
                    <textarea placeholder='Enter here...' rows={2} cols={1} value={values.remarks} name='remarks' onChange={handleChange} />
                    <ErrorMessage name='remarks' component='div' className='error-msg' />
                  </div>
                </div>
              </div>
              <div className='labelClass'>
                <div className='innerClass'>
                  <Calendar
                    label='Next Follow-Up Date'
                    name='nextFollowupDate'
                    // width='48%'
                    value={values.nextFollowupDate}
                    onChange={(values) => setFieldValue('nextFollowupDate', convertDateFormatCalendar(values))}
                  />
                </div>
                <div className='innerClass inquiryForm-input'>
                    <label htmlFor=''>Status</label>
                    <div className='button-group'>
                      <Button
                        customClassName={selectedStatus === 'alive' ? 'active-btn' : 'inactive-btn'}
                        type='button'
                        onClick={() => {
                          setSelectedStatus('alive')
                          setFieldValue('inquiryStatus', 'alive') // Update Formik state
                        }}
                      >
                        Alive
                      </Button>
                      <Button
                        customClassName={selectedStatus === 'dead' ? 'active-btn' : 'inactive-btn'}
                        type='button'
                        onClick={() => {
                          setSelectedStatus('dead')
                          setFieldValue('inquiryStatus', 'dead') // Update Formik state
                        }}
                      >
                        Dead
                      </Button>
                    </div>
                  </div>
              </div>
            </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>}
    </>
  )
}

export default AddInquiryForm
